import React from "react";
import FIcon from "@components/FIcon";

interface ContentCaptionProps {
  caption: string;
  isEditable: boolean;
  onClick?: () => void;
}

const ContentCaption: React.FC<ContentCaptionProps> = ({
  caption,
  isEditable,
  onClick,
}) => {
  return (
    <div className="flex bg-white mt-8 w-full flex-col items-start rounded-lg">
      <p className="text-sm text-dark_night_sky">
        Content caption for all deliverables
        <span className="text-red ml-1">*</span>
      </p>
      <div
        className={`flex w-full items-stretch mt-2 border border-default_weak overflow-hidden bg-white rounded-lg ${isEditable ? "cursor-pointer" : ""}`}
        onClick={isEditable ? onClick : undefined}
      >
        <div className="flex-grow px-4 py-2 text-left overflow-hidden">
          <h2 className="text-sm leading-[24px] text-dark truncate">
            {caption}
          </h2>
        </div>
        <button
          className="text-sm bg-white px-4 py-2 min-w-[85px] h-auto flex-shrink-0 flex items-center gap-2 text-dark_night_sky border-l border-default_weak"
          onClick={onClick}
        >
          <FIcon icon="edit" size={14} color="#000F45" />
          <span>Edit</span>
        </button>
      </div>
    </div>
  );
};

export default ContentCaption;
